export const take = <O, T extends Record<string | number, unknown> = Record<string, unknown>>(
  input: Partial<Record<keyof T, unknown>>,
  ...keys: Array<keyof T>
): O => {
  return keys.reduce((acc, k): Partial<O> => {
    const v = input[k];
    if (typeof v === 'undefined') {
      return acc;
    }
    return { ...acc, [k]: v };
  }, {}) as O;
};
